import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "warn-text"
}
const _hoisted_3 = {
  key: 2,
  class: "ok-text"
}
const _hoisted_4 = {
  key: 0,
  class: "path-line"
}
const _hoisted_5 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_6 = {
  key: 1,
  class: "empty-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderWithMenu, {
        title: "Очередь конвертации",
        scrolled: _ctx.headerScrolled
      }, null, 8, ["scrolled"]),
      _createVNode(_component_ion_content, {
        class: _normalizeClass([_ctx.isMobile ? 'main-background' : 'liga-web-background']),
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card, { class: "admin-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("Состояние", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Загрузка…"))
                    : (!_ctx.snapshot?.available)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.snapshot?.message || 'Очередь недоступна'), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_3, "RabbitMQ доступен. Показаны ожидающие задачи и видео медиатеки, которые уже конвертируются.")),
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    fill: "outline",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadQueue())),
                    disabled: _ctx.loading
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode(" Обновить ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, { class: "admin-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Ожидают в очереди (" + _toDisplayString(_ctx.waiting.length) + ")", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  (_ctx.waiting.length)
                    ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.waiting, (item) => {
                            return (_openBlock(), _createBlock(_component_ion_item, {
                              key: item.itemKey,
                              class: "queue-row"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h2", null, _toDisplayString(item.displayName), 1),
                                    _createElementVNode("p", null, _toDisplayString(_ctx.taskTypeLabel(item.taskType)), 1),
                                    (item.sectionFolderKey || item.inputPath)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(item.sectionFolderKey || item.inputPath), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_button, {
                                  slot: "end",
                                  fill: "clear",
                                  color: "danger",
                                  onClick: ($event: any) => (_ctx.confirmRemove(item)),
                                  disabled: _ctx.removingKey === item.itemKey
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "icon-only",
                                      icon: _ctx.trashOutline
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }, 8, ["onClick", "disabled"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("p", _hoisted_5, "Очередь пуста."))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, { class: "admin-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Сейчас конвертируются (" + _toDisplayString(_ctx.processing.length) + ")", 1)
                    ]),
                    _: 1
                  }),
                  _cache[3] || (_cache[3] = _createElementVNode("p", { class: "card-hint" }, "Видео медиатеки в статусе PROCESSING, которых уже нет в очереди. Отмена остановит ffmpeg у воркера.", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  (_ctx.processing.length)
                    ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processing, (item) => {
                            return (_openBlock(), _createBlock(_component_ion_item, {
                              key: item.itemKey,
                              class: "queue-row"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h2", null, _toDisplayString(item.displayName), 1),
                                    _createElementVNode("p", null, _toDisplayString(_ctx.taskTypeLabel(item.taskType)) + " · id " + _toDisplayString(item.videoId), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                (item.videoId)
                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 0,
                                      slot: "end",
                                      fill: "clear",
                                      color: "warning",
                                      onClick: ($event: any) => (_ctx.confirmCancelProcessing(item)),
                                      disabled: _ctx.cancellingId === item.videoId
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          slot: "icon-only",
                                          icon: _ctx.stopCircleOutline
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["onClick", "disabled"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("p", _hoisted_6, "Нет активных конвертаций медиатеки вне очереди."))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class", "onIonScroll"])
    ]),
    _: 1
  }))
}